<template>
  <div class="w-full flex flex-col">
    <!-- <pre>{{ advanceMethodOptions }}</pre> -->
    <b-field
        label="Metodo de registro de avance">
        <b-select v-model="form.avance_method" placeholder="Selecione el metodo de avance" expanded>
            <option v-for="(item, i) in advanceMethodOptions"
              :value="item.value" :key="'amo_'+i">{{ item.text }}</option>
        </b-select>
    </b-field>

    <b-field
        label="Criterio de ponderación de los estados">
        <b-select v-model="form.weighting_criteria"
          placeholder="Seleccione como ponderan los estados"
          :disabled="!form.avance_method"
          expanded
        >
          <option v-for="(item, i) in stateWeightingCriteriaOptions"
            :value="item.value" :key="'swco_'+i">{{ item.text }}</option>
        </b-select>
    </b-field>

    <b-field
        label="Visibilidad de los estados de progreso">
        <b-select v-model="form.visibility_progress"
          placeholder="Seleccione la visibilidad de los estados de progreso"
          expanded
        >
          <option v-for="(item, i) in statusesVisibilityOptions"
            :value="item.value" :key="'svco_'+i">{{ item.text }}</option>
        </b-select>
    </b-field>

    <b-field
        label="Visibilidad de los estados de incidencia">
        <b-select v-model="form.visibility_incidents"
          placeholder="Seleccione la visibilidad de los estados de incidencia"
          expanded
        >
          <option v-for="(item, i) in statusesVisibilityOptions"
            :value="item.value" :key="'svco_'+i">{{ item.text }}</option>
        </b-select>
    </b-field>

    <b-field
        label="Permitir seleccionar multiples estados de progreso">
        <b-select v-model="form.select_multiple_progress"
          placeholder="Seleccione si se permite seleccionar multiples estados de progreso"
          expanded
          disabled
        >
          <option v-for="(item, i) in registerMultipleStatusesOptions"
            :value="item.value" :key="'smso_'+i">{{ item.text }}</option>
        </b-select>
    </b-field>

    <b-field
        label="Permitir seleccionar multiples estados de incidencia">
        <b-select v-model="form.select_multiple_incidents"
          placeholder="Seleccione si se permite seleccionar múltiples estados de incidencia"
          expanded
        >
          <option v-for="(item, i) in registerMultipleStatusesOptions"
            :value="item.value" :key="'smso_'+i">{{ item.text }}</option>
        </b-select>
    </b-field>
  </div>
</template>

<script>
import { advanceMethodOptions, stateWeightingCriteriaOptions,
  statusesVisibilityOptions, registerMultipleStatusesOptions } from '../../data/select.options.js'

export default {
  name: 'LayerStatusesConfigForm',

  props: {
    config: {
      type: Object,
      default: null
    },
  },

  data() {
    return {
      advanceMethodOptions,
      stateWeightingCriteriaOptions,
      statusesVisibilityOptions,
      registerMultipleStatusesOptions,

      form: {
        avance_method: this.config?.avance_method ?? null,
        weighting_criteria: this.config?.weighting_criteria ?? null,
        visibility_progress: this.config?.visibility?.progress ?? 'visible_default',
        visibility_incidents: this.config?.visibility?.incidents ?? 'visible_default',
        visibility_progress_roles: this.config?.visibility?.progress_roles ?? null,
        visibility_incidents_roles: this.config?.visibility?.incidents_roles ?? null,
        select_multiple_progress: this.config?.select_multiple?.progress ?? 'single',
        select_multiple_incidents: this.config?.select_multiple?.incidents ?? 'single',
      }
    }
  },

  methods: {
    getData() {
      return {
        avance_method: this.form.avance_method,
        weighting_criteria: this.form.weighting_criteria,
        visibility: {
          progress: this.form.visibility_progress,
          progress_roles: this.form.visibility_progress_roles,
          incidents: this.form.visibility_incidents,
          incidents_roles: this.form.visibility_incidents_roles,
        },
        select_multiple: {
          progress: this.form.select_multiple_progress,
          incidents: this.form.select_multiple_incidents,
        }
      };
    }
  }
}
</script>
